import { render, staticRenderFns } from "./DropFile.vue?vue&type=template&id=570049ef&scoped=true&"
import script from "./DropFile.vue?vue&type=script&lang=js&"
export * from "./DropFile.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/dropfile.css?vue&type=style&index=0&id=570049ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570049ef",
  null
  
)

export default component.exports